import { useForm } from 'react-hook-form'
import { signUpPatientResolver } from 'resolvers'

function useSignUpPatientForm() {
  return useForm({
    mode: 'onBlur',
    resolver: signUpPatientResolver,
    defaultValues: {
      cpf: '',
      email: '',
      emailValidationCode: '',
      whatsapp: '',
      whatsappValidationCode: '',
      communication: [],
      firstName: '',
      lastName: '',
      birthdate: '',
      pronoun: '',
      password: '',
      confirmPassword: '',
      acceptedShare: false,
      acceptedTermsAndPolicies: false,
    },
  })
}

export default useSignUpPatientForm
